import React from "react";
import ReactDOM from "react-dom/client";
import { TakuProvider } from "./providers/TakuProvider";
import { StaffProvider } from "./providers/StaffProvider";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./dnd-polyfill";
import "antd/dist/antd.css";
import "./i18n/i18n";

window.addEventListener("beforeinstallprompt", (e) => {
  // Ngăn không cho lời mời cài đặt ứng dụng hiển thị
  e.preventDefault();
  // Lưu lại sự kiện để sau này có thể hiển thị lời mời cài đặt (nếu cần)
  window.deferredPrompt = e;
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <React.Fragment>
    <StaffProvider>
      <TakuProvider>
        <App />
      </TakuProvider>
    </StaffProvider>
  </React.Fragment>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
